import React, {useEffect, useRef, useState} from 'react';
import './style.scss';
import {Popup} from '../../../../components';
import {APP_PRIZE_COINS} from '../../../../constants';

export const PopupTaskTrailer = ({onCheck, onClose}) => {
    const [closed, setClosed] = useState(false);
    const [fullHeight, setFullHeight] = useState(false);
    const [showTrailer, setShowTrailer] = useState(false);

    const inputRef = useRef(null);

    const verify = () => {
        const code = inputRef.current.value.trim().toUpperCase();
        if (0 < code.length) {
            onCheck(code);
        }
    }

    useEffect(() => {
        window.setTimeout(() => setShowTrailer(true), 256);
    }, []);

    return <Popup
        title="Введи код из видео"
        buttonText="Ввести код"
        onButtonClick={() => {
            setFullHeight(false);
            verify();
        }}
        onClose={onClose}
        closed={closed}
        fullHeight={fullHeight}
    >
        <div className="app-popup-task-trailer--video">{showTrailer &&
            <video
                src="https://lovikwami-test-bot.store/video/video_for_game.mp4"
                playsInline
                controls
                autoPlay
            />
        }</div>
        <input
            ref={inputRef}
            className="app-popup-task-trailer--input"
            type="text"
            placeholder="Подсказка: код состоит из 8 букв"
            maxLength={8}
            onFocusCapture={() => setFullHeight(true)}
        />
        {!fullHeight && <div className="app-popup--description">
            Посмотри видео, найди в&nbsp;нем скрытый код<br/>
            и введи его в&nbsp;текстовое поле выше.&nbsp;
            Если код окажется верным, ты получишь +<strong><span>{APP_PRIZE_COINS.TRAILER}&nbsp;баллов</span></strong>
        </div>}
    </Popup>;
}